import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ReactDOM from 'react-dom';
import ModalVideo from 'react-modal-video';
import UserLoginType from '../../../views/login/UserLoginType';
import Whatsapp from '../../../views/login/Whatsapp.js';

import ProductConfig from '../../../config/ProductConfig.json';
import HmAjax from '../../../util/HmAjax';
import PreLoginPage from '../../../views/core/PreLoginPage';

// ES6 class-style
class ProductMenu extends PreLoginPage {

	constructor (props) {
		super(props);
		
	    this.state = {
		  error: null,
	      isLoaded: false,
	      items: [],
	      ProductList: [],
	      pro_detail: [],
	      products : [],
	      self: [],
	      plp:[],
	      products_details: {},
	      products_category_order:[]
	    }
		
		this.grades = this.props.grades;
	    this.productClass = this.props.products_class;
	    this.productDetails = this.props.products_details;
	    this.products_category = this.props.products_category;
	    this.productClasses = this.props.classes;
	    this.renderFooterProduct = this.renderFooterProduct.bind(this);
	    this.restricted = false;
	  }

	  componentDidMount() {

	  	const { products,self,plp } = this.state;
	  	this.grades = this.props.grades;
	  	this.productClass = this.props.products_class;
	  	this.productDetails = this.props.products_details;
	  	this.products_category = this.props.products_category;
	  	this.productClasses = this.props.classes;
		// console.log("this.state ",this.state,this.products_category)
	}

	  loadlessoncomp(){
		  var me=this;
		return(
			<div>
				{me.loadsplcomp()}
                {me.loadplpcomp()}
                {me.loadcbsecomp()}
				</div>
		)
	}



	getProdDetails(){
		//console.log(this.state.products_details);
	   if(this.state.products_details !== {} && this.state.products_details !== undefined){
	   return this.state.products_details;
	 }
   }

	renderFooterProduct(product,grade){
		//console.log(product,", ",grade,", ",this.productClasses);
		if(product && grade && this.products_category && this.products_category[product] && this.products_category[product].hasOwnProperty(grade)){ 			
			var restricted = ""
			if(this.GradeRestrictionManager.isGradeRestricted(grade)){
				restricted = "restricted";
				this.restricted = true;
			}
			return (<div key={grade}><a className={restricted} id={this.productClasses[grade].ClassName} data-ga={'Classes - Menu - '+ProductConfig[product].ganame+' - '+this.productClasses[grade].ClassName}  onClick={() => this.saveID(`${grade}`,`${this.products_category[product][grade]}`,ProductConfig[product].url+this.products_category[product][grade])}>
				{this.productClasses[grade].ClassName}
				{(() => {
					  if(restricted == "restricted"){
						  return "*";
					  }
			  })()}
			</a></div>);		   
		}  		
	}

	
	saveID(grade,proID,link){
		const {products_details} = this.state;
		var me =this;
		var callBackSuccess = function(result){
	  if(result !== null){
		  
		  me.setState({
			products_details: result
		  }),
		 //console.log("Footer:::",me.getProdDetails());
			 localStorage.setItem('grade',grade);
			localStorage.setItem('product',proID);
		  localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));

		  window.top.location.href=link;

	  }

	  //console.log("response : ", response);
	  }
  
	  var callBackFailure = function(response){
		  me.setState({
			  isLoaded: true,
			  error:"Error in Footer PRODUCT_JSON"
			});
		  console.log("Error in Footer PRODUCT_JSON in Grade");		
	  }
  
	  var formData = {
			  "levelId":grade
	  }
	  new HmAjax(this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);
	  
	  //console.log(grade);
		//console.log(proID);
		
	}

    
    loadsplcomp(){
		var me=this;
		return(
			<div className="splwell">
			<div className="row">
				
				<div><span className="spltxt">{this.rb("SPL")}</span></div>
				</div>
				
				<div className="row atagalign">
				
				{me.orderProducts(me.state.products_category_order).map(product => {
					
					if(me.checkRestrictedGrade(product,me.grades) == false){
						if(product=="SPL"){
						return(
							<div className="aelement" key={product}>
									{me.grades.map(grade => (
										me.renderFooterProduct(product,grade)	
									))}	<br></br>			
							</div> 
						);
							}
					}
			})}
				
				</div>
				</div>
)
    }

	loadplpcomp(){
		var me=this;
		return(
			<div className="splwell">
			<div className="row">
				
				<div><span className="plptxt">{this.rb("PLP")}</span></div>
				
				</div>
				<div className="row atagalign">
			
				
				{me.orderProducts(me.state.products_category_order).map(product => {
					
					if(me.checkRestrictedGrade(product,me.grades) == false){
						if(product=="PLP" || product=="EXAM_PREP_CBSE"){
						return(
							<div className="aelement" key={product}>
									{me.grades.map(grade => (
										me.renderFooterProduct(product,grade)	
									))}						
							</div> 
						);
							}
					}
			})}

				
				</div>
				</div>
)
    }
    
	checkRestrictedGrade(product,grades){		
		//console.log("grades:::",grades, ", ",product);
		//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
	  var restrictedAvailable = false;
	  if(grades && grades.length > 0){			
		  for(var i=0;i<grades.length;i++){
			if(product && this.products_category && this.products_category[product] && this.products_category[product].hasOwnProperty(grades[i])){ 
					if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){
						restrictedAvailable = true;
						break;
					}
			  }
		  }
	  }else{ restrictedAvailable = true; }
	  
	  return restrictedAvailable;
	 }


 orderProducts(obj){
	if(obj && typeof obj === "object"){
		//console.log("Object.values(obj) "+Object.values(obj))
		return Object.values(obj);
	}else{
		return [];
	}
 }


  render() {
	const { products,self,plp } = this.state;
	this.grades = this.props.grades;
	this.grades_order = this.props.grades_order;
	this.productClass = this.props.products_class;
	this.productDetails = this.props.products_details;
	this.products_category = this.props.products_category;
	this.productClasses = this.props.classes;
	this.state.products_category_order = this.props.products_category_order;
	
    const tifOptions = [];
    
  	return(
        <div id="productmenu" className="dropdown-menu">
        <div className="dropdown-item">
        {this.loadsplcomp()}
            </div>	

            <div className="dropdown-item">
        {this.loadplpcomp()}
            </div>
      </div>
  	);
  }
}

export default ProductMenu;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/ProductMenu.js